<template>
  <div class="w-full">
    <div class="my-3">
      <h1 class="h1 text-grey-light-900 font-semibold text-3xl">Verify Email Address</h1>
      <p class="text-sm font-normal text-black">
        A verification link has been sent to {{ userStore.user.email }}. Please check your email and verify your
        account.
      </p>
      <p v-if="errorMessage" class="text-error-700">{{ errorMessage }}</p>
    </div>
    <div class="justify-content-center mt-4">
      <p class="mt-3 text-sm text-black">
        Haven't received the link?
        <button
          v-if="!isLoading"
          class="btn p-0 text-sm text-brand-700 hover:underline"
          @click="resendEmailVerification"
        >
          Resend email verification.
        </button>
        <span v-if="isLoading">
          <LayupSpinner class="text-brand-700" small />
        </span>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { getMe, sendEmailVerification } from '@/services/auth';
import { useUserStore } from '@/stores/users';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';

const userStore = useUserStore();
const toast = useToast();
const router = useRouter();

const errorMessage = ref('');
const isLoading = ref(false);

const resendEmailVerification = async () => {
  errorMessage.value = '';
  isLoading.value = true;
  const data = {
    name: userStore.user.name,
    email: userStore.user.email,
    _id: userStore.user._id,
    redirectTo: `${import.meta.env.VITE_BASE_URL}/email-verification-success`,
  };

  await sendEmailVerification(data)
    .then(() => toast.success('Email verification link was sent successfully.', { position: 'top' }))
    .catch(() => (errorMessage.value = 'Sending email verification was unsuccessfully. Please try again later.'));

  isLoading.value = false;
};

const startEmailVerificationPolling = () => {
  const interval = setInterval(async () => {
    const user = await getMe();
    if (user.verifiedEmail) {
      clearInterval(interval);
      router.push({ name: 'EmailVerificationSuccess' });
    }
  }, 5000);
};
startEmailVerificationPolling();
</script>
